// Date shown on a proof card. Off means no date at all; on means the full
// day, month and year rather than the short "Jan 8" the tweet grid used.
//
// Defaults to on, so a widget nobody has touched keeps showing what it
// showed before the setting existed.
export const datesEnabled = (widget) => (widget?.design?.show_dates ?? widget?.show_dates) !== false;

export const formatProofDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" });
};

// Compact form for dense card chrome, e.g. the Futuristic corner tag:
// 2026.09.01. Zero padded so every card is the same width in a monospace row.
export const formatProofDateShort = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}.${pad(d.getMonth() + 1)}.${pad(d.getDate())}`;
};
